export default __webpack_public_path__ + "static/media/SecondImage.0ac243c0.png";